export const MUTATION_KEYS = {
    representativeInvitationV3: 'representativeInvitationV3',
    deleteRepresentativeV3: 'deleteRepresentativeV3',
    updateRepresentativeV3: 'updateRepresentativeV3'
}

export const QUERY_KEYS = {
    representativeDetailsV3: 'representativeDetailsV3',
    representativesV3: 'representativesV3',
    representativeAcceptRequestV3: 'representativeAcceptRequestV3',
    representativeHostsV3: 'representativeHostsV3',
    representativeHostsChannelsV3: 'representativeHostsChannelsV3'
}
